import React from 'react';

const ContactFooter: React.FC = () => (
  <footer className="site-footer">
    <div className="footer-email-strip">
      <span>💬</span>
      <p>
        Let's talk! We can set up a time to discuss your plan, feel free to contact me by email:{' '}
        <a href="mailto:deaftaxlady@gmail.com">deaftaxlady@gmail.com</a>
      </p>
    </div>
    <p className="footer-copy">DeafWise Planning &amp; Taxes 2025</p>
    <p className="footer-credit">Website by Cody Yandura</p>
  </footer>
);

export default ContactFooter;
